<!-- NavigationBar.vue -->
<template>
  <nav
    class="bg-bg border-bg fixed bottom-0 z-50 flex h-auto w-full items-center justify-around border-t-2 pt-0 pb-[env(safe-area-inset-bottom)] shadow-lg md:top-0 md:left-0 md:h-full md:w-20 md:flex-col md:justify-start md:gap-6 md:border-t-0 md:border-r-2 md:pt-[max(1.5rem,env(safe-area-inset-top))] md:pb-0 md:pl-[env(safe-area-inset-left)]"
  >
    <NavItem :icon="Telescope" label="Goals" href="/home" :paths="['/category', '/task']" />
    <NavItem :icon="Book" label="Courses" href="/courses" />
    <NavItem :icon="HeartHandshake" label="Toolbox" href="/tools" />
    <NavItem :icon="Cog" label="Settings" href="/settings" />
    <!--    <NavItem icon="🏠" label="Home" />-->
    <!--    <NavItem icon="📚" label="Learn" />-->
    <!--    <NavItem icon="👤" label="Profile" />-->
  </nav>
</template>

<script setup lang="ts">
import NavItem from './NavItem.vue';
import { Telescope, HeartHandshake, Cog, Book } from 'lucide-vue-next';
</script>
